<div @dialogAnimation>
    <div class="flex-block">
        <h2 class="admin-subheader dialog-actions-center">Kontaktiere uns!</h2>
        <p class="admin-text">
            Hast Du Fragen oder interessierst Du Dich für unser Angebot? Kontaktiere uns auf dem Weg, der für Dich am
            bequemsten ist. Wir freuen uns auf Deine Nachricht!</p>
        <div class="contact-container">
            <div class="item">
                <button mat-mini-fab class="costum-mat-surface-container-low dialog-actions-center"
                aria-label="Geschäft per Telefon kontaktieren" (click)="sendWhatsApp()">
                <img src="assets/icons/whatsapp.svg" width="24" height="24" alt="WhatsApp-Icon" />
                </button>
                <p class="admin-text">{{CONTACT.mobile}}</p>
            </div>
            <div class="item">
                <button mat-mini-fab class="costum-mat-surface-container-low dialog-actions-center"
                    aria-label="Geschäft per Smartphone kontaktieren" (click)="callMobile()">
                    <mat-icon class="material-icons-outlined">smartphone</mat-icon>
                </button>
                <p class="admin-text">{{CONTACT.mobile}}</p>
            </div>
            <div class="item">
                <button mat-mini-fab class="costum-mat-surface-container-low dialog-actions-center"
                    aria-label="Geschäft per Email kontaktieren" (click)="sendEmail()">
                    <mat-icon class="material-icons-outlined">mail</mat-icon>
                </button>
                <p class="admin-text">{{CONTACT.email}}</p>
            </div>
        </div>
    </div>
</div>